import React from "react";
import { IoAdd } from "react-icons/io5";

export default function NovaCategoriaDesafios({ onClick, animation }) {
  return (
    <div className={`${animation} flex justify-center items-center`}>
      <button
        type="button"
        onClick={onClick}
        className="w-full h-full flex justify-center items-center touchable-opacity border-2 rounded-[30px]"
      >
        <IoAdd size={78} />
      </button>
    </div>
  );
}
